/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Ai_Setup_StagingInputs */

const cs_property_ai_setup_staging = /** @type {(inputs: Property_Ai_Setup_StagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavit staging`)
};

const en_property_ai_setup_staging = /** @type {(inputs: Property_Ai_Setup_StagingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setup staging`)
};

/**
* | output |
* | --- |
* | "Setup staging" |
*
* @param {Property_Ai_Setup_StagingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_ai_setup_staging = /** @type {((inputs?: Property_Ai_Setup_StagingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Ai_Setup_StagingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_ai_setup_staging(inputs)
	return cs_property_ai_setup_staging(inputs)
});